/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import { Link } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import Layout from './layout';
import TableOfContents from './table-of-contents';
import LanguageLink from './language-link';

const PostsPage = ({ page }) => {
  const isSpanish = typeof window !== "undefined"
    ? window.location.pathname.includes("/es/")
    || !!window.location.pathname.match(/^.*\/es$/)
    : false;

  return (
    <Layout pageTitle={page.title} pageExcerpt={page.excerpt}>
      <h1 sx={{ mb: 0 }}>{page.title}</h1>
      {page.created}<br />
      {page.isInternationalized && 
        <LanguageLink 
          isInternationalized={page.isInternationalized}
          language={page.language}
          pathname={page.path}
        />
      }
      <hr />

      <MDXRenderer>{page.body}</MDXRenderer>
      <p
        sx={{
          borderTop: (theme) => `1px solid ${theme.colors.muted}`,
          color: 'grey',
          fontSize: 14,
          mt: 2,
          pt: 2,
        }}
      >
        This page was updated {page.updated}<br />
        &copy; 2022 edX Boot Camps LLC. Confidential and Proprietary. All Rights Reserved.
      </p>
      <p sx={{ variant: 'taxonomy.regular' }}>
        Category: <Link to={page.language === 'es' ? '/es' + page.category.path : page.category.path}>{page.category.name}</Link>
      </p>
      {page.tags && (
        <p sx={{ variant: 'taxonomy.regular' }}>
          {isSpanish ? 'Etiquetado en:' : 'Tagged under:'}{' '}
          {page.tags.map(({ name, path }, i, tagsArr) => (
            <React.Fragment key={path}>
              <Link to={page.language === 'es' ? '/es' + path : path}>{name}</Link>
              {i < tagsArr.length && ', '}
            </React.Fragment>
          ))}
        </p>
      )}
      <TableOfContents />
    </Layout>
  );
};

export default PostsPage;
